import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { useNavigate } from 'react-router-dom';
import './musicscanner.css';

function MusicScanner() {
  const [selectedCategory, setSelectedCategory] = useState('common');
  const navigate = useNavigate();

  const commonQRData = [
    { url: 'https://youtu.be/Gd-y-4ePBCQ', title: 'PASSIONIT PRUTL KALKI Generative AI Museum' },
    { url: 'https://youtu.be/I3Iwe6sQZqM', title: 'Shikhandi - PASSIONIT PRUTL KALKI Generative AI Museum' },
    { url: 'https://youtu.be/5VeI4NK0onI', title: 'नाम घे रे, कर्म फुलव रे' },
    { url: 'https://youtu.be/80rc76p68KI', title: 'Kanchuka HQ' },
    { url: 'https://youtu.be/HxFIL7cOfqE', title: 'Man Mukta Kar' },
    { url: 'https://youtu.be/aKZg-4Cs56E', title: 'Guru Purnima' },
    { url: 'https://youtu.be/uK7RSDUzqYQ', title: 'Sanatan Embrace Love' },
    { url: 'https://youtu.be/AZPhKYijYLc', title: 'Salma With Love ' },
    { url: 'https://youtu.be/1qL4fusZl4Q?feature=shared', title: 'Tehzeeb Tehzeeb' },
    { url: 'https://youtu.be/u2Ak6_RzFn4', title: 'Convenant Spanish English' },
    { url: 'https://youtu.be/7fk7zcSzeXc', title: 'PARBRAHMAN RAHMAN' },
  ];

  const vinylBoardData = [
    { url: 'https://tinyurl.com/2je7jnar', title: 'Ek Dharti, Ek Geet – Krishnas Global Song' },
    { url: 'https://tinyurl.com/yc7pb3yb', title: 'Dear Meri Suno, Bas Jao Na -Devi' },
    { url: 'https://tinyurl.com/2s475dhk', title: 'Guna Groove with Krishna' },
    { url: 'https://tinyurl.com/2zzrjsbw', title: 'KALKI का आगमन – घोड़े की टापों संग' },
    { url: 'https://tinyurl.com/rvzxk86h', title: 'Mujh Mein Bas Tu' },
    { url: 'https://tinyurl.com/m4rffax4', title: 'VISHWAGURU BANEGA INDIA' },
    { url: 'https://tinyurl.com/5n93mpbn', title: 'छीन लो रौशनी – हम हैं छाया की रानी' },
    { url: 'https://tinyurl.com/7rfupwhn', title: 'Record Khul Gaya!' },
    { url: 'https://tinyurl.com/5a7zdb4m', title: 'धरा एक, राहें हज़ार' },
    { url: 'https://tinyurl.com/432ykcb7', title: 'BANEGA DHARMA KARMA YOGI' },
    { url: 'https://tinyurl.com/ycbbunw2', title: 'Dekh rahi hain' },
    { url: 'https://tinyurl.com/mr2tb486', title: 'Dwarka Mai' },
    { url: 'https://tinyurl.com/bdw3t476', title: 'Ek Hi Raah – One Path, Many Ways' },
    { url: 'https://tinyurl.com/46jfuvey', title: 'Garuda Ki Pukar' },
    { url: 'https://tinyurl.com/msup9psa', title: 'KEHNA HAIN...' },
    { url: 'https://tinyurl.com/2s3fzu9w', title: 'Khuda Mere Dil Mein Hai_ (God Resides Within Me)' },
    { url: 'https://tinyurl.com/3n7mdx3e', title: 'Sach Ka Darpan - Interfaith' },
    { url: 'https://tinyurl.com/23yzv839', title: 'Urja Urja' },
    ];

  const sunoNaAllData = [
    { url: 'https://tinyurl.com/3tnz6ju6', title: 'Allkalki…Prem Ki Tech Wali Dastaan' },
    { url: 'https://tinyurl.com/m89ubjbf', title: 'Suno Na  - Kannada' },
    { url: 'https://tinyurl.com/2s4kps2j', title: 'Suno Na  - Bengali' },
    { url: 'https://tinyurl.com/mhpw7dxp', title: 'Suno Na  - Bhojpuri' },
    { url: 'https://tinyurl.com/y7rzdxwb', title: 'Suno Na  - Garhwali' },
    { url: 'https://tinyurl.com/d3un6bhs', title: 'Suno Na  - Konkani' },
    { url: 'https://tinyurl.com/5u7rspwt', title: 'Suno Na  - Malayalam' },
    { url: 'https://tinyurl.com/mmhkf6n7', title: 'Suno Na  - Marathi' },
    { url: 'https://tinyurl.com/4z3ppza3', title: 'Suno Na  - Marwari' },
    { url: 'https://tinyurl.com/3b5xkhy6', title: 'Suno Na  - Oriya' },
    { url: 'https://tinyurl.com/5n6wf82v', title: 'Suno Na  - Telugu' },
    { url: 'https://tinyurl.com/3esyk4kw', title: 'Suno Na  - Urdu' },
    { url: 'https://tinyurl.com/dk5vkz6c', title: 'Suno Na  - Tamil' },
  ];

  let displayData = [];
  if (selectedCategory === 'common') displayData = commonQRData;
  else if (selectedCategory === 'vinyl') displayData = vinylBoardData;
  else if (selectedCategory === 'suno') displayData = sunoNaAllData;

  return (
    <div className="qr-scroll-container">
      {/* Heading and Buttons */}
      <div style={{ textAlign: 'center', marginBottom: '40px' }}>
        <h2 style={{ marginBottom: '20px', fontSize: '32px' }}>🎼 Music QR Codes</h2>

        <div style={{ display: 'inline-flex', gap: '20px', marginBottom: '10px' }}>
          <button onClick={() => setSelectedCategory('common')} className="qr-button">
            All Youtube Songs
          </button>
          <button onClick={() => setSelectedCategory('vinyl')} className="qr-button">
            Vinyl Board
          </button>
          <button onClick={() => setSelectedCategory('suno')} className="qr-button">
            Suno Na All
          </button>
        </div>
      </div>

      {/* QR Code Grid */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '40px', justifyContent: 'center' }}>
        {displayData.map((item, index) => (
          <div key={index} style={{ textAlign: 'center' }}>
            <QRCodeSVG value={item.url} size={128} />
            <p style={{ marginTop: '10px', fontWeight: 'bold' }}>QR {index + 1}</p>
            <p style={{ fontSize: '14px', color: '#ccc' }}>{item.title}</p>
          </div>
        ))}
      </div>

      {/* Go Back Button */}
      <div style={{ textAlign: 'center', marginTop: '50px' }}>
        <button
          onClick={() => navigate('/admincommon')}
          className="qr-button"
          style={{ padding: '10px 25px', fontSize: '16px' }}
        >
          ⬅️ Go Back to Admin Panel
        </button>
      </div>
    </div>
  );
}

export default MusicScanner;
